export const FooterMenuStrings = {
  legalNotice: 'Legal Notice',
  dataFileDescription: 'Data File Description',
  privacyStatement: 'Privacy Statement',
  termsAndConditions: 'Terms & Conditions',
  contact: 'Contact',
  contactInformation: `KONE CORPORATION FINLAND, KONE OYJ, KEILASATAMA 3, P.O. BOX 7, ESPOO, 02150, FINLAND (苏ICP备17069255号-2 | 沪公网安备 31010502002858号)
  `,
}
